import { render } from "./ItemVeMobile.vue?vue&type=template&id=dd9e1774&scoped=true"
import script from "./ItemVeMobile.vue?vue&type=script&lang=js"
export * from "./ItemVeMobile.vue?vue&type=script&lang=js"

import "./ItemVeMobile.vue?vue&type=style&index=0&id=dd9e1774&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\TraCuuVe_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9e1774"]])

export default __exports__